import { LOCAL_STORAGE_GRID_KEYS } from "../_constants";
import { getGridContextMenuList } from "../_helpers/getGridContextMenuList";
import { LabelColumnV2 } from "../components/DataGridV2/DataColumnsV2";

export const getBuyerChangeGridColumns = ({ t, i18n, keyPrefix, apiRef }) => {
  
  const getOptions = getGridContextMenuList({
    filterKey:LOCAL_STORAGE_GRID_KEYS.CHANGE_BUYER_DIALOG_COLUMN_FILTER[keyPrefix],
    sortKey: LOCAL_STORAGE_GRID_KEYS.CHANGE_BUYER_DIALOG_COLUMN_SORT[keyPrefix],
    i18n,
    t,
    apiRef,
    mode: "client",
  });

  return [
    {
      field: "searchName",
      headerName: t("general.searchName"),
      flex: 1,
      minWidth: 100,
      renderCell: (params) => {
        const request = params.row;
        return (
          <LabelColumnV2
            label={request.searchName}
            cellSubMenuOptions={{
              options: getOptions({
                field: "searchName",
                isQuickFilterDisplay: Boolean(request.searchName),
              }),
              extraData: { fieldName: "searchName" },
            }}
            request={request}
          />
        );
      },
    },
    {
      field: "fullName",
      headerName: t("buyersGuide.buyerActions.change.fullName"),
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        const request = params.row;
        return (
          <LabelColumnV2
            label={request.FullName}
            cellSubMenuOptions={{
              options: getOptions({
                field: "fullName",
                isQuickFilterDisplay: Boolean(request.fullName),
              }),
              extraData: { fieldName: "fullName" },
            }}
            request={request}
          />
        );
      },
    },
    {
      field: "correspondenceAddress",
      headerName: t("buyersGuide.buyerActions.correspondenceAddress"),
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        const request = params.row;
        return (
          <LabelColumnV2
            label={request.correspondenceAddress}
            cellSubMenuOptions={{
              options: getOptions({
                field: "correspondenceAddress",
                isQuickFilterDisplay: Boolean(request.correspondenceAddress),
              }),
              extraData: { fieldName: "correspondenceAddress" },
            }}
            request={request}
          />
        );
      },
    },
    {
      field: "buyerRenterType ",
      headerName: t("general.type"),
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        const request = params.row;
        return (
          <LabelColumnV2
            label={request.buyerRenterType}
            cellSubMenuOptions={{
               options: getOptions({
                field: "buyerRenterType",
                isQuickFilterDisplay: Boolean(request.buyerRenterType),
              }),
              extraData: { fieldName: "buyerRenterType" },
            }}
            request={request}
          />
        );
      },
    },
    {
      field: "status",
      headerName: t("general.status"),
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        const request = params.row;
        return (
          <LabelColumnV2
            label={request.status}
            cellSubMenuOptions={{
              options: getOptions({
                field: "status",
                isQuickFilterDisplay: Boolean(request.status),
              }),
              extraData: { fieldName: "status" },
            }}
            request={request}
          />
        );
      },
    },
  ];
};
